<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Lizenzen</h1>
                    <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                            <route-bread-crumb></route-bread-crumb>
                                        </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
            <!--            <div class="row">
                            <div class="col-xl-3 col-lg-6">
                                <stats-card title="Alle"
                                            type="gradient-orange"
                                            :sub-title="total"
                                            icon="fad fa-tasks"
                                            class="mb-4 mb-xl-0">
                                    <template v-slot:footer>
                                        <span class="text-nowrap">Seit letztem Monat</span>
                                    </template>
                                </stats-card>
                            </div>
                            <div class="col-xl-3 col-lg-6">
                                <stats-card title="Abgerechnet"
                                            type="gradient-green"
                                            sub-title="2"
                                            icon="fad fa-badge-check"
                                            class="mb-4 mb-xl-0">
                                    <template v-slot:footer>
                                        <span class="text-danger mr-2">50 %</span>
                                        <span class="text-nowrap">Abrechnungsquote</span>
                                    </template>
                                </stats-card>

                            </div>
                            <div class="col-xl-3 col-lg-6">
                                <stats-card title="Betrag (aktueller Monat)"
                                            type="gradient-blue"
                                            sub-title="332.50"
                                            icon="fad fa-calendar-alt"
                                            class="mb-4 mb-xl-0">
                                    <template v-slot:footer>
                                        <span class="text-success mr-2">
                                            <i class="fad fa-arrow-up"></i>
                                            700.00 %
                                        </span>
                                        <span class="text-nowrap">zum letzten Monat</span>
                                    </template>
                                </stats-card>
                            </div>
                            <div class="col-xl-3 col-lg-6">
                                <stats-card title="Höchster Betrag"
                                            type="gradient-info"
                                            sub-title="237.50"
                                            icon="fad fa-bell"
                                            class="mb-4 mb-xl-0">
                                    <template v-slot:footer>
                                       <span class="text-success mr-2">
                                            <i class="fad fa-arrow-up"></i>
                                            500.00 %
                                        </span>
                                        <span class="text-nowrap">zum letzten Monat</span>
                                    </template>
                                </stats-card>
                            </div>
                        </div>-->
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row" v-if="loading">
                <div class="col">
                    <div class="card shadow">
                        <div class="loaderInfo"><img class="loader" src="img/loading.gif" alt="loader"></div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="!loading">
                <div class="col">
                    <div class="card shadow"
                         :class="type === 'dark' ? 'bg-default': ''">
                        <div class="col">
                            <div class="row mt-3">
                                <div class="col col-lg-2">
                                    <el-select
                                        v-model="activeMonth"
                                        class="btn-block"
                                        no-match-text="Kein Eintrag"
                                        default-first-option
                                        filterable
                                        placeholder="Monat">
                                        <el-option
                                            v-for="(possibleMonth, index) in possibleMonths"
                                            :key="index"
                                            :value="possibleMonth.number"
                                            :label="possibleMonth.name">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="col col-lg-1">
                                    <el-select
                                        v-model="activeYear"
                                        class="btn-block"
                                        no-match-text="Kein Eintrag"
                                        default-first-option
                                        filterable
                                        placeholder="Jahr">
                                        <el-option
                                            v-for="(possibleYear, index) in possibleYears"
                                            :key="index"
                                            :value="possibleYear"
                                            :label="possibleYear">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="col col-offset-4"></div>
                                <div class="pt-3 col col-lg-2 flex-column flex-md-row">
                                    <span class="float-right">Vergleich mit Vormonat</span>
                                </div>
                                <div class="pt-3 col col-lg-1">
                                    <base-switch onText="" offText="" type="primary" :modelValue="comparison"
                                                 @changed="comparison = !comparison"></base-switch>
                                </div>
                            </div>
                            <tabs fill class="flex-column flex-md-row" type="warning" :activeTab="activeTab">
                                <card shadow>
                                    <tab-pane markRaw class="pb-4"
                                              v-for="item in contexts"
                                              :id="item.id"
                                              :title="item.name">
                                        <licenses-table :licenses="item.licenses"
                                                        :userLicenses="userLicenses"
                                                        :comparison="comparison"
                                                        :month="monthArray.find(x => x.number === activeMonth).name"
                                        ></licenses-table>
                                    </tab-pane>
                                </card>
                            </tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {ref, watch, computed, onMounted} from 'vue';
import Tab from "@/components/Tabs/Tab";
import Tabs from "@/components/Tabs/Tabs";
import TabPane from "@/components/Tabs/TabPane";
import LicensesTable from "@/views/Tables/LicensesTable";
import UserService from '@/services/user.service';
import BaseSwitch from "@/components/BaseSwitch";
import {
    ElInput,
    ElSelect,
    ElOption,
} from "element-plus";

export default {
    name: "Licenses",
    components: {
        Tab,
        Tabs,
        TabPane,
        LicensesTable,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        BaseSwitch,
    },
    props: {
        type: {
            type: String,
            default: ""
        }
    },
    setup() {
        const total = ref('0');
        const loading = ref(false);
        const error = ref('');
        const activeTab = ref('');
        const contexts = ref([]);
        const licenses = ref([]);
        const userLicenses = ref([]);
        const serverLicenses = ref([]);
        const comparisonData = ref([]);

        const padTo2Digits = (num) => {
            return num.toString().padStart(2, '0');
        }

        const comparison = ref(false);
        const currentDate = ref(new Date());
        const activeYear = ref(currentDate.value.getFullYear().toString());
        const activeMonth = ref(padTo2Digits(currentDate.value.getMonth() + 1));

        const possibleYears = ref([]);
        for (let i = 2023; i <= activeYear.value; i++) {
            possibleYears.value.push(i.toString());
        }

        const monthArray = [
            {"name": "Januar", "number": "01"},
            {"name": "Februar", "number": "02"},
            {"name": "März", "number": "03"},
            {"name": "April", "number": "04"},
            {"name": "Mai", "number": "05"},
            {"name": "Juni", "number": "06"},
            {"name": "Juli", "number": "07"},
            {"name": "August", "number": "08"},
            {"name": "September", "number": "09"},
            {"name": "Oktober", "number": "10"},
            {"name": "November", "number": "11"},
            {"name": "Dezember", "number": "12"},
        ];

        const possibleMonths = computed(() => {
            if (activeYear.value === currentDate.value.getFullYear().toString()) {
                return monthArray.filter((item, idx) => (parseInt(item.number) <= padTo2Digits(currentDate.value.getMonth() + 1)));
            } else {
                return monthArray;
            }
        });

        const getLicenses = () => {
            loading.value = true;
            if (activeYear.value + activeMonth.value === "202301") {
                comparison.value = false;
            }
            UserService.getLicenses(activeYear.value + activeMonth.value, comparison.value).then(
                response => {
                    licenses.value = response.data.licenses;
                    userLicenses.value = response.data.userLicenses;
                    serverLicenses.value = response.data.serverLicenses;
                    if (comparison.value) {
                        licenses.value.forEach(entry => {
                            entry.total_number_of_licenses_pre_user = 0;
                            entry.total_number_of_licenses_user = 0;
                            response.data.comparison.userLicenses.forEach(user => {
                                if (entry.software_license_id === user.software_license_id || entry.own_software_label === user.readable_label) {
                                    entry.total_number_of_licenses_pre_user++;
                                }
                            });
                            response.data.userLicenses.forEach(user => {
                                if (entry.software_license_id === user.software_license_id || entry.own_software_label === user.readable_label) {
                                    entry.total_number_of_licenses_user++;
                                }
                            });
                            entry.total_number_of_licenses_pre = (response.data.comparison.licenses.find(x => x.unique_report_identifier === entry.unique_report_identifier)) ? response.data.comparison.licenses.find(x => x.unique_report_identifier === entry.unique_report_identifier).total_number_of_licenses : 0;
                        });
                        userLicenses.value.forEach(entry => {
                            if (response.data.comparison.userLicenses.find(x => x.installed_software_id === entry.installed_software_id) == null) {
                                entry.object_label += '(+)';
                            }
                        });
                        response.data.comparison.userLicenses.forEach(entry => {
                            if (userLicenses.value.find(x => x.installed_software_id === entry.installed_software_id) == null) {
                                let insertEntry = entry;
                                insertEntry.object_label += "(-)";
                                userLicenses.value.push(insertEntry);
                            }
                        });
                    } else {
                        licenses.value.forEach(entry => {
                            entry.total_number_of_licenses_user = 0;
                            response.data.userLicenses.forEach(user => {
                                if (entry.software_license_id === user.software_license_id || entry.own_software_label === user.readable_label) {
                                    entry.total_number_of_licenses_user++;
                                }
                            });
                        });
                    }
                    let licenseLabels = [];
                    let itemsToDelete = [];
                    licenses.value.forEach((entry, index, licenses) => {
                        if (entry.termDuration && entry.termDuration !== '') {
                            entry.numberYearly = 0;
                            entry.numberMonthly = 0;
                            if(licenseLabels.includes(entry.friendlyName)) {
                                const firstIndex = licenses.findIndex(obj => {
                                    return obj.friendlyName === entry.friendlyName;
                                })
                                licenses[firstIndex].total_number_of_licenses += entry.total_number_of_licenses;
                                if(comparison.value) {
                                    licenses[firstIndex].total_number_of_licenses_pre += entry.total_number_of_licenses_pre;
                                }
                                if(entry.termDuration.slice(-1) == 'Y') {
                                    licenses[firstIndex].numberYearly += entry.total_number_of_licenses;
                                    licenses[firstIndex].endDateYearly = entry.commitmentEndDate;
                                }
                                if(entry.termDuration.slice(-1) == 'M') {
                                    licenses[firstIndex].numberMonthly += entry.total_number_of_licenses;
                                    licenses[firstIndex].endDateMonthly = entry.commitmentEndDate;
                                }
                                itemsToDelete.push(index);
                            } else {
                                if(entry.termDuration.slice(-1) == 'Y') {
                                    entry.numberYearly += entry.total_number_of_licenses;
                                    entry.endDateYearly = entry.commitmentEndDate;
                                }
                                if(entry.termDuration.slice(-1) == 'M') {
                                    entry.numberMonthly += entry.total_number_of_licenses;
                                    entry.endDateMonthly = entry.commitmentEndDate;
                                }
                            }
                            licenseLabels.push(entry.friendlyName);
                        }
                    });
                    itemsToDelete.forEach((entry, index) => {
                        licenses.value.splice(entry - index, 1);
                    })
                    loading.value = false;
                },
                error => {
                    getError(error);
                }
            );
        }

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (request.response && request.response.data) ||
                    request.message ||
                    request.toString();
            }
        }

        const getContexts = () => {
            contexts.value = [];
            licenses.value.forEach(entry => {
                if (contexts.value.length === 0 || (!contexts.value.some(e => e.id === entry.license_context))) {
                    contexts.value.push({
                        id: entry.license_context,
                        name: (entry.license_context_label == 'Andere Benutzer-Lizenzen') ? 'RIO Lizenzen' : entry.license_context_label,
                        licenses: []
                    });
                }
                const index = contexts.value.map(function (e) {
                    return e.id;
                }).indexOf(entry.license_context);
                contexts.value[index].licenses.push(entry);
            });
            if (contexts.value.length !== 0) {
                contexts.value.sort((a, b) => (a.id > b.id) ? 1 : -1);
                activeTab.value = contexts.value[0].id;
            }
        }

        watch(licenses, getContexts);
        watch(activeYear, getLicenses);
        watch(activeMonth, getLicenses);
        watch(comparison, getLicenses);

        onMounted(() => {
            getLicenses()
        });

        return {
            getLicenses,
            getError,
            error,
            userLicenses,
            serverLicenses,
            licenses,
            comparisonData,
            contexts,
            total,
            activeTab,
            loading,
            comparison,
            monthArray,
            possibleYears,
            possibleMonths,
            activeYear,
            activeMonth
        };
    },
};
</script>
<style scoped lang="scss">
.loaderInfo {
    width: 100%;
    padding: 10px;
    text-align: center;
}

.loader {
    max-width: 100%;
}
</style>
